var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getFilteredMissionsWithShiftsFunctionDef, } from '../../../../backend/features/mission/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React, { useEffect } from 'react';
import useSWR from 'swr';
import { useMissionActions } from './useMissionActions';
import { useMissionsAnalytics } from './useMissionsAnalytics';
export const missionsFetchKey = 'missions';
const missionDisplayLimit = 10;
export const useMissions = (params) => {
    var _a, _b;
    const getFilteredMissionsWithShiftsPlatformFn = useTypedPlatformFunction(getFilteredMissionsWithShiftsFunctionDef);
    const fetchMissionsWithShifts = (params) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield getFilteredMissionsWithShiftsPlatformFn(params);
        return result; // TODO: Remove Type Casting after PLAT-2704
    });
    const { closeMission: closeMissionAction, mobilizeMission: mobilizeMissionAction } = useMissionActions();
    const { fetchMissionAnalytics } = useMissionsAnalytics();
    const [myTotalShiftsByMissionId, setMyTotalShiftsByMissionId] = React.useState({});
    const [missionLimit, setMissionsLimit] = React.useState(missionDisplayLimit);
    const fetchMissions = () => {
        const orderBy = params.sortBy ? [params.sortBy] : undefined;
        return fetchMissionsWithShifts({
            additionalFilters: transformFilterValuesToFilters(params.activeFilters),
            sortBy: orderBy,
            isVolunteerView: params.isVolunteerView,
        })
            .then((data) => {
            let fetchedMissions = data;
            if (params.shouldCalculateMyMissions) {
                setMyTotalShiftsByMissionId(calculateMyTotalShifts(fetchedMissions));
            }
            if (params.displayMyMissions) {
                fetchedMissions = filteredMissionsByParticipation(data);
            }
            return fetchedMissions;
        })
            .catch(handleErrorSnackbar);
    };
    const { data: missions, mutate, isLoading } = useSWR([missionsFetchKey, params.isVolunteerView], fetchMissions, defaultFetcherOptions);
    useEffect(() => {
        if (isLoading) {
            return;
        }
        mutate();
    }, [params.sortBy, params.activeFilters, params.displayMyMissions, isLoading, mutate]);
    const closeMission = (missionId) => {
        if (!missions) {
            return;
        }
        return closeMissionAction(missionId).then(() => fetchMissionAnalytics());
    };
    const mobilizeMission = (missionId) => {
        if (!missions) {
            return;
        }
        return mobilizeMissionAction(missionId).then(() => fetchMissionAnalytics());
    };
    const loadMoreMissions = () => {
        if (!missions) {
            return;
        }
        setMissionsLimit((prevState) => prevState + missionDisplayLimit);
    };
    return {
        displayedMissions: { total: (_a = missions === null || missions === void 0 ? void 0 : missions.total) !== null && _a !== void 0 ? _a : 0, rows: (_b = missions === null || missions === void 0 ? void 0 : missions.rows.slice(0, missionLimit)) !== null && _b !== void 0 ? _b : [] },
        loadMoreMissions,
        myTotalShiftsByMissionId,
        closeMission,
        mobilizeMission,
        isLoading,
        fetchMissions: mutate,
    };
};
function transformFilterValuesToFilters(activeFilters) {
    return activeFilters.map((filter) => ({ column: filter.column, op: 'in', value: filter.value }));
}
function filteredMissionsByParticipation(missions) {
    const filteredRows = missions.rows.filter((m) => m.userParticipation.pendingShiftParticipations > 0 || m.userParticipation.approvedShiftParticipations > 0);
    return { rows: filteredRows, total: filteredRows.length };
}
function calculateMyTotalShifts(missions) {
    const myTotalShift = {};
    missions.rows.forEach((mission) => {
        myTotalShift[mission.id] = mission.userParticipation.approvedShiftParticipations;
    });
    return myTotalShift;
}
